(function($){
    $(window).scroll(function(){
        if ($(this).scrollTop() > 150) {
            $('.gotop').css('opacity', 1);
        } else {
            $('.gotop').css('opacity', 0);
        }
    });

    $('.gotop').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    })
})(jQuery)